import React from 'react';
import { Alert, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PassesTable from './management/PassesTable';
import { EXPIRING_SOON_DAYS } from './PassesFilter/PassesFilterContext';
import { mb } from '../common/theme/mbTokens';

export const AtRiskPasses = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box sx={{ px: mb.layout.cardPadding, pt: mb.layout.cardPadding, flexShrink: 0 }}>
        <Alert
          severity="info"
          variant="outlined"
          sx={{ maxWidth: 720, '& .MuiAlert-message': { minWidth: 0, whiteSpace: 'normal' } }}>
          {t('passes.at_risk.intro')}
          <Box component="ol" sx={{ m: '4px 0', paddingInlineStart: 3 }}>
            <li>{t('passes.at_risk.buckets.membership_payment_failed')}</li>
            <li>{t('passes.at_risk.buckets.membership_cancelled')}</li>
            <li>{t('passes.at_risk.buckets.expired')}</li>
            <li>{t('passes.at_risk.buckets.expiring', { days: EXPIRING_SOON_DAYS })}</li>
            <li>{t('passes.at_risk.buckets.zero_punches')}</li>
          </Box>
          {t('passes.at_risk.exclusion')}
        </Alert>
      </Box>
      <PassesTable atRiskMode />
    </>
  );
};
